<div class="input-container">
    <mat-form-field appearance="outline" class="full-width">
        <mat-label *ngIf="label()">{{ label() }}</mat-label>

        <div matPrefix *ngIf="startIcon()" class="icon-container">
            <app-svg-icon [iconPath]="startIcon()" alt="icon" class="input-icon"> </app-svg-icon>
        </div>

        <input
            #inputElement
            matInput
            [maxlength]="maxLength()"
            [type]="inputType"
            [placeholder]="placeholder()"
            [formControl]="control()"
            [required]="required()"
            (blur)="onTouched()"
            (input)="handleInput($event)"
        />
        <div matSuffix>
            <button
                mat-icon-button
                *ngIf="!endIcon() && isPassword"
                (click)="togglePasswordVisibility($event)"
                [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'"
            >
                <app-svg-icon
                    [iconPath]="
                        isPasswordVisible ? '/assets/img/new-designs/icons/password-toggle-off.svg' : '/assets/img/new-designs/icons/password-toggle.svg'
                    "
                    alt="icon"
                    class="input-icon"
                    [style.cursor]="isPassword ? 'pointer' : 'default'"
                >
                </app-svg-icon>
            </button>
            <div (click)="onEndIconClick($event)" [style.cursor]="'pointer'">
                <app-svg-icon *ngIf="endIcon() && !isPassword" [iconPath]="endIcon()" alt="icon" class="input-icon"> </app-svg-icon>
            </div>
        </div>

        <mat-error *ngIf="errorMessage()">
            {{ errorMessage() }}
        </mat-error>
    </mat-form-field>
</div>
